import { Modal, Nav } from "react-bootstrap";
import { useState } from "react";
import { SurveyMeter2 } from "./Subcomponents/SurveyMeter2";
import { DiliTextCP } from "../Utility/DiliTextCP";
import useLocalStorage from "../../hooks/useLocalStorage";
import { localStorageVariables } from "../../constants";
import Checkbox from "../Checkbox";
import { FaRegFrown, FaRegSmile } from "react-icons/fa";
import { isClient, submitSurvey } from "../../services/accountService";
import useDecodeToken from "../../hooks/useDecodeToken";
import handleApiError from "../../helpers/handleApiError";
import { toast } from "react-toastify";
import RequiredStar from "../Utility/FormElements/RequiredStar";
import { escapeHTML, isValidEmail } from "../../helpers/utilities";
import { useMemo } from "react";

export const CustomerSurveySideBySide = ({
  show,
  onHide,
  // setLastMonthShown,
  // currentMonthAndYear,
  setLoading,
  // design,
  // setDesign,
}) => {
  const [decodeToken] = useDecodeToken();
  const [surveyFormValues, setSurveyFormValues] = useState({
    deliveryServiceRating: null,
    averageDeliveryTimeRating: null,
    deliveryDriverRating: null,
    packageHandlingRating: null,
    otherComps: "",
    howWeCompare: "",
    howToImproveDeliveryExperience: "",
    canContact: null,
    name: "",
    phoneNumber: "",
    emailAddress: "",
  });
  const [submissionAttempted, setSubmissionAttempted] = useState(false);
  const handleChangeSurveyFormValues = (e) => {
    if (e.target.name === "contact-yes") {
      setSurveyFormValues({ ...surveyFormValues, canContact: true });
      return;
    }
    if (e.target.name === "contact-no") {
      setSurveyFormValues({ ...surveyFormValues, canContact: false });
      return;
    }
    setSurveyFormValues({
      ...surveyFormValues,
      [e.target.name]: e.target.value,
    });
  };
  const checkInputsInvalid = () => {
    if (surveyFormValues.deliveryServiceRating === null) {
      toast.error(
        "Please enter a rating for overall delivery service provided.",
      );
      return true;
    }
    if (surveyFormValues.averageDeliveryTimeRating === null) {
      toast.error("Please enter a rating for average delivery time.");
      return true;
    }
    if (surveyFormValues.deliveryDriverRating === null) {
      toast.error("Please enter a rating for your delivery driver.");
      return true;
    }
    if (surveyFormValues.packageHandlingRating === null) {
      toast.error(
        "Please enter a rating for overall quality of package handling.",
      );
      return true;
    }
    if (surveyFormValues.packageHandlingRating === null) {
      toast.error(
        "Please enter a rating for overall quality of package handling.",
      );
      return true;
    }
    if (surveyFormValues.canContact === null) {
      toast.error("Please select an option for whether we may contact you.");
      return true;
    }
    if (surveyFormValues.canContact && surveyFormValues.name === "") {
      toast.error("Please enter a name for contact.");
      return true;
    }
    if (
      surveyFormValues.canContact &&
      surveyFormValues.phoneNumber === "" &&
      surveyFormValues.emailAddress === ""
    ) {
      toast.error("Please enter a phone number and/or email for contact.");
      return true;
    }
    if (surveyFormValues.canContact && surveyFormValues.phoneNumber !== "") {
      if (surveyFormValues.phoneNumber.length < 10) {
        toast.error("Please enter a valid phone number.");
        return true;
      }
    }
    if (surveyFormValues.canContact && surveyFormValues.emailAddress !== "") {
      if (!isValidEmail(surveyFormValues.emailAddress)) {
        toast.error("Please enter a valid email.");
        return true;
      }
    }
  };

  const handleInvalid = (e) => {
    // console.log(e);
    setSubmissionAttempted(true);
    //get mileage data from cxt
    //make model year
    //1. depreciation value based on make model year
    //2. local gas prices
    //pay out reimbursement
    //70c per mile irs
    //everland motos pays like 30c based on car make/model/year and local gas prices
    //employees get paid out of paychex so we would need a report that gets reimb per driver
    //employees driver in california get paid same us (verify)
    //april 30th
    // checkInputsInvalid();
  };
  // console.log(submissionAttempted);
  const handleSubmitSurvey = async (e) => {
    setSubmissionAttempted(true);

    e.preventDefault();

    if (checkInputsInvalid()) {
      return;
    }

    try {
      setLoading(true);
      await submitSurvey(
        decodeToken.CustomerName,
        surveyFormValues.deliveryServiceRating,
        surveyFormValues.averageDeliveryTimeRating,
        surveyFormValues.deliveryDriverRating,
        surveyFormValues.packageHandlingRating,
        escapeHTML(surveyFormValues.otherComps),
        escapeHTML(surveyFormValues.howWeCompare),
        escapeHTML(surveyFormValues.howToImproveDeliveryExperience),
        surveyFormValues.canContact ?? false,
        escapeHTML(surveyFormValues.name),
        escapeHTML(surveyFormValues.phoneNumber),
        escapeHTML(surveyFormValues.emailAddress),
      );
      toast.success("Thank you for your feedback!");
      // setLastMonthShown(currentMonthAndYear);
      onHide(); //sets last month shown
    } catch (ex) {
      handleApiError(ex);
    } finally {
      setLoading(false);
    }
  };
  // console.log(surveyFormValues);
  return (
    <>
      <Modal show={show} onHide={onHide} size="xl" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="tw-flex-1 tw-text-center">
            Satisfaction Survey
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmitSurvey} onInvalid={handleInvalid}>
          <Modal.Body>
            {/* {show && <DesignSelector design={design} setDesign={setDesign} />} */}
            <div className="tw-grid lg:tw-grid-cols-2 lg:tw-gap-4">
              <div className="lg:tw-border-r-2 lg:tw-border-y-0 lg:tw-border-l-0 lg:tw-border-r-gray-200 lg:tw-border-solid">
                <div className="tw-px-4">
                  <SurveyMeter2
                    name="deliveryServiceRating"
                    value={surveyFormValues.deliveryServiceRating}
                    setValue={handleChangeSurveyFormValues}
                    label={
                      <p className="survey-label m-0">
                        How would you rate the overall delivery service provided
                        by Diligent Delivery Systems? <RequiredStar />
                      </p>
                    }
                    levels={5}
                    worstLabel={<FaRegFrown size={30} color="#555" />}
                    bestLabel={<FaRegSmile size={30} color="#555" />}
                  />
                  <SurveyMeter2
                    name="averageDeliveryTimeRating"
                    value={surveyFormValues.averageDeliveryTimeRating}
                    setValue={handleChangeSurveyFormValues}
                    label={
                      <p className="survey-label m-0">
                        How satisfied are you with your average delivery time?{" "}
                        <RequiredStar />
                      </p>
                    }
                    levels={5}
                    worstLabel={<FaRegFrown size={30} color="#555" />}
                    bestLabel={<FaRegSmile size={30} color="#555" />}
                  />
                  <SurveyMeter2
                    name="deliveryDriverRating"
                    value={surveyFormValues.deliveryDriverRating}
                    setValue={handleChangeSurveyFormValues}
                    label={
                      <p className="survey-label m-0">
                        How would you rate your delivery driver?{" "}
                        <RequiredStar />
                      </p>
                    }
                    levels={5}
                    worstLabel={<FaRegFrown size={30} color="#555" />}
                    bestLabel={<FaRegSmile size={30} color="#555" />}
                  />

                  <SurveyMeter2
                    name="packageHandlingRating"
                    value={surveyFormValues.packageHandlingRating}
                    setValue={handleChangeSurveyFormValues}
                    label={
                      <p className="survey-label m-0">
                        How would you rate the overall quality of the package
                        handling? <RequiredStar />
                      </p>
                    }
                    levels={5}
                    worstLabel={<FaRegFrown size={30} color="#555" />}
                    bestLabel={<FaRegSmile size={30} color="#555" />}
                  />
                </div>
              </div>

              <div>
                <div className="tw-grid tw-gap-y-2 tw:px-4">
                  <p className="survey-label mb-0">
                    What other companies do you receive deliveries from?
                  </p>
                  <DiliTextCP
                    type="textarea"
                    placeholder="Names of other companies"
                    name="otherComps"
                    onChange={handleChangeSurveyFormValues}
                    value={surveyFormValues.otherComps}
                    maxLength={500}
                    displayTextAreaCharacterCountNotCol
                  />
                  <p className="survey-label mb-0 mt-2">
                    How do we compare and why?
                  </p>
                  <DiliTextCP
                    type="textarea"
                    placeholder="We'd love your feedback"
                    name="howWeCompare"
                    onChange={handleChangeSurveyFormValues}
                    value={surveyFormValues.howWeCompare}
                    maxLength={500}
                    displayTextAreaCharacterCountNotCol
                  />
                  <p className="survey-label mb-0 mt-2">
                    What can we do to improve your delivery experience?
                  </p>
                  <DiliTextCP
                    type="textarea"
                    placeholder="Suggestions, improvements, feedback"
                    name="howToImproveDeliveryExperience"
                    onChange={handleChangeSurveyFormValues}
                    value={surveyFormValues.howToImproveDeliveryExperience}
                    maxLength={500}
                    displayTextAreaCharacterCountNotCol
                  />
                  <p className="survey-label mb-0 mt-2">
                    May we contact you regarding your response? <RequiredStar />
                  </p>
                  <Checkbox
                    label="Yes"
                    name="contact-yes"
                    onChange={handleChangeSurveyFormValues}
                    checked={surveyFormValues.canContact === true} // check for true and false specifically because I don't want either to be selected while it's null initially.
                  />
                  <Checkbox
                    label="No"
                    name="contact-no"
                    onChange={handleChangeSurveyFormValues}
                    checked={surveyFormValues.canContact === false} // check for true and false specifically because I don't want either to be selected while it's null initially.
                  />
                  {console.log(submissionAttempted)}
                  {surveyFormValues.canContact && (
                    <>
                      <DiliTextCP
                        placeholder="Name"
                        name="name"
                        onChange={handleChangeSurveyFormValues}
                        // required
                        // wasSubmitted={submissionAttempted}
                        // validationTest={(value) => value?.length > 1}
                      />
                      <DiliTextCP
                        placeholder="Phone Number"
                        name="phoneNumber"
                        type="tel"
                        maxLength="12"
                        onChange={handleChangeSurveyFormValues}
                        // required={surveyFormValues.emailAddress === ""}
                        // wasSubmitted={submissionAttempted}
                        // validationTest={(value) =>
                        //   value >= 10 ||
                        //   surveyFormValues.emailAddress.length > 0
                        // }
                      />
                      <DiliTextCP
                        placeholder="Email Address"
                        name="emailAddress"
                        // type="email"
                        onChange={handleChangeSurveyFormValues}
                        // required={surveyFormValues.phoneNumber === ""}
                        // wasSubmitted={submissionAttempted}
                        // validationTest={(value) =>
                        //   isValidEmail(value) ||
                        //   surveyFormValues.phoneNumber.length > 0
                        // }
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onHide}
            >
              Close
            </button>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
export const CustomerSurveySbSColor = ({ show, onHide, design, setDesign }) => {
  const [canContact, setCanContact] = useState();
  const handleChangeCanContact = (e) => {
    if (e.target.name === "contact-yes") {
      setCanContact(true);
    }
    if (e.target.name === "contact-no") {
      setCanContact(false);
    }
  };
  return (
    <>
      <Modal show={show} onHide={onHide} size="xl">
        <Modal.Body className="p-0">
          {/* {show && <DesignSelector design={design} setDesign={setDesign} />} */}
          <div className="tw-grid lg:tw-grid-cols-2">
            <div
              className="lg:tw-border-r-2z lg:tw-border-y-0 lg:tw-border-l-0 lg:tw-border-r-gray-200z lg:tw-border-solidz"
              style={{ backgroundColor: "#007ac2" }}
            >
              <h3 className="tw-p-4 tw-pb-2 tw-text-white">
                Satisfaction Survey
              </h3>
              <div className="tw-px-4 tw-py-4">
                <SurveyMeter2
                  meterBaseColor="rgb(195 195 195)"
                  meterContainerStyle={{
                    backgroundColor: "white",
                    padding: "0rem .7rem",
                    borderRadius: "10px",
                  }}
                  containerClass="py-1"
                  label={
                    <p className="survey-label mt-2 mb-3">
                      How would you rate the overall delivery service provided
                      by Diligent Delivery Systems?
                    </p>
                  }
                  levels={5}
                />
                <SurveyMeter2
                  label={
                    <p className="survey-label mt-2 mb-3">
                      How satisfied are you with your average delivery time?
                    </p>
                  }
                  meterBaseColor="rgb(195 195 195)"
                  meterContainerStyle={{
                    backgroundColor: "white",
                    padding: "0rem .7rem",
                    borderRadius: "10px",
                  }}
                  containerClass="py-1"
                  levels={5}
                />
                <SurveyMeter2
                  label={
                    <p className="survey-label mt-2 mb-3">
                      How would you rate your delivery driver?
                    </p>
                  }
                  meterBaseColor="rgb(195 195 195)"
                  meterContainerStyle={{
                    backgroundColor: "white",
                    padding: "0rem .7rem",
                    borderRadius: "10px",
                  }}
                  containerClass="py-1"
                  levels={5}
                />

                <SurveyMeter2
                  label={
                    <p className="survey-label mt-2 mb-3">
                      How would you rate the overall quality of the package
                      handling?
                    </p>
                  }
                  meterBaseColor="rgb(195 195 195)"
                  meterContainerStyle={{
                    backgroundColor: "white",
                    padding: "0rem .7rem",
                    borderRadius: "7px",
                  }}
                  containerClass="py-1"
                  levels={5}
                />
              </div>
            </div>

            <div className="tw-flex tw-flex-col tw-justify-between tw-relative tw-overflow-hidden">
              <div className="survey-background-shear"></div>
              <div className="tw-grid tw-gap-y-2 tw-px-4 tw-py-4 tw-z-10">
                <p className="survey-label mb-0">
                  What other companies do you receive deliveries from?
                </p>
                <DiliTextCP
                  type="textarea"
                  placeholder="Names of other companies"
                />
                <p className="survey-label mb-0 mt-2">
                  How do we compare and why?
                </p>
                <DiliTextCP
                  type="textarea"
                  placeholder="We'd love your feedback"
                />
                <p className="survey-label mb-0 mt-2">
                  What can we do to improve your delivery experience?
                </p>
                <DiliTextCP
                  type="textarea"
                  placeholder="Suggestions, improvements, feedback"
                />
                <p className="survey-label mb-0 mt-2">
                  May we contact you regarding your response?
                </p>
                <Checkbox
                  label="Yes"
                  name="contact-yes"
                  onClick={handleChangeCanContact}
                  checked={canContact === true}
                />
                <Checkbox
                  label="No"
                  name="contact-no"
                  onClick={handleChangeCanContact}
                  checked={canContact === false}
                />
                {canContact && (
                  <>
                    <DiliTextCP placeholder="Name" />
                    <DiliTextCP placeholder="Phone Number" />
                    <DiliTextCP placeholder="Email Address" />
                  </>
                )}
              </div>
              <div className="tw-py-2 tw-flex tw-justify-end tw-gap-2 tw-mt-auto tw-px-4 tw-mb-2 tw-z-10">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onHide}
                >
                  Skip This Month
                </button>
                <button type="button" className="btn btn-primary">
                  Submit Feedback
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
const DesignSelector = ({ design, setDesign }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: "30px",
        left: "30px",
        width: "300px",
        height: "100px",
        zIndex: 999999999,
      }}
    >
      <select
        className="form-control"
        value={design}
        onChange={(e) => {
          setDesign(parseInt(e.target.value));
        }}
      >
        <option value={1}>SideBySide</option>
        <option value={2}>SideBySide Colored</option>
      </select>
    </div>
  );
};

// 72605648;

// 38763936;

const todayDate = new Date();
// console.log(todayDate.getDate());
const isFirstWeekOfMonth = todayDate.getDate() <= 10;
const CUSTOMER_SURVEY_MONTHS = [2, 5, 8, 11]; // March, June, September, December (0-indexed)
const CLIENT_SURVEY_MONTHS = [3, 6, 9, 0]; // April, July, October, January (0-indexed)

// console.log(todayDate.getMonth());
// console.log(firstWeek);
const currentMonthAndYear =
  todayDate.getFullYear() + "-" + (todayDate.getMonth() + 1);
export const CustomerSurvey = ({ setLoading }) => {
  const [decodedToken] = useDecodeToken();
  const isClientAccount = useMemo(() => isClient(decodedToken), [decodedToken]);
  // console.log(isClientAccount);

  const isClientSurveyMonth = CLIENT_SURVEY_MONTHS.includes(
    todayDate.getMonth(),
  );
  const isCustomerSurveyMonth = CUSTOMER_SURVEY_MONTHS.includes(
    todayDate.getMonth(),
  );

  const [lastMonthYearShown, setLastMonthYearShown] = useLocalStorage({
    key: localStorageVariables.surveyLastMonthCompleted,
    initialValue: "",
  });
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setLastMonthYearShown(currentMonthAndYear);
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [design, setDesign] = useState(1);

  // console.log(lastMonthShown);
  // console.log(currentMonthAndYear);
  // const shouldShowSurvey = lastMonthShown !== currentMonthAndYear || show; // This version for being able to click a button to re-open the survey
  const shouldShowCustomerSurvey =
    !isClientAccount &&
    isCustomerSurveyMonth &&
    isFirstWeekOfMonth &&
    lastMonthYearShown !== currentMonthAndYear; //This version for automatic popup for first week of month that goes away until next time once interacted with.

  const shouldShowClientSurvey =
    isClientAccount &&
    isClientSurveyMonth &&
    isFirstWeekOfMonth &&
    lastMonthYearShown !== currentMonthAndYear; //This version for automatic popup for first week of month that goes away until next time once interacted with.

  // const handleSubmitSurvey = () => {
  //   setLastMonthShown(currentMonthAndYear);
  // };

  return (
    <>
      {/* <Nav.Link onClick={handleShow}>
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-x-1">
          <div>Feedback</div>
        </div>
      </Nav.Link> */}
      {shouldShowCustomerSurvey && (
        <>
          {design === 1 && (
            <CustomerSurveySideBySide
              show={shouldShowCustomerSurvey}
              onHide={handleClose}
              // setLastMonthShown={setLastMonthShown}
              currentMonthAndYear={currentMonthAndYear}
              setLoading={setLoading}
              design={design}
              setDesign={setDesign}
            />
          )}
          {design === 2 && (
            <CustomerSurveySbSColor
              show={shouldShowCustomerSurvey}
              onHide={handleClose}
              design={design}
              setDesign={setDesign}
            />
          )}
        </>
      )}
    </>
  );
};
